import PageLayout from '../../layout/PageLayout/PageLayout';
import Card from '../../components/Card/Card';
import CardLoader from '../../components/Loader/Loader';
import { IconUpdated } from '../../icons/Icons';
import { ERoutes } from '../../util/constants';
import { Redirect } from 'react-router-dom';
import styles from './ChangeEmailStaffScreen.module.scss';
import common from '../../util/scss/common.module.scss';
import ChangeEmailStaffContext, {
    ChangeEmailStaffProvider,
    EChangeEmailStaffUiState,
} from '../../contexts/ChangeEmailStaffContext';
import GlobalContext from '../../contexts/GlobalContext';
import { replacePhrase } from '../../util/helpers';
import { FC, useContext } from 'react';

const ChangeEmailStaffSuccess: FC = () => {
    const { language } = useContext(GlobalContext);
    const { email, customerAccountName } = useContext(ChangeEmailStaffContext);
    const formattedDesc = replacePhrase(language.changeEmail.staffDesc, '<accountName>', customerAccountName);

    return (
        <Card>
            <section className={common.icon}>
                <IconUpdated />
            </section>
            <header>
                <h1 className={common.pageHeader}>{language.changeEmail.header}</h1>
            </header>
            <main>
                <p className={styles.email}>{email}</p>
            </main>
            <footer className={styles.footer} data-testid="desc">
                <p>{formattedDesc}</p>
            </footer>
        </Card>
    );
};

const ChangeEmailStaffUi: FC = () => {
    const { changeEmailStaffUiState } = useContext(ChangeEmailStaffContext);
    let changeEmailUi: React.ReactElement;
    switch (changeEmailStaffUiState) {
        case EChangeEmailStaffUiState.default:
        case EChangeEmailStaffUiState.queryStringParsed:
            changeEmailUi = <CardLoader />;
            break;
        case EChangeEmailStaffUiState.error:
            changeEmailUi = <Redirect to={ERoutes.error} />;
            break;
        case EChangeEmailStaffUiState.success:
            changeEmailUi = <ChangeEmailStaffSuccess />;
            break;
        default:
            throw new Error('Change Email Ui State Set Incorrectly');
    }
    return changeEmailUi;
};

const ChangeEmailStaffScreen: FC = () => {
    return (
        <ChangeEmailStaffProvider>
            <PageLayout>
                <ChangeEmailStaffUi />
            </PageLayout>
        </ChangeEmailStaffProvider>
    );
};

export default ChangeEmailStaffScreen;
